import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ref: ref, ...props, children: _jsx("path", { d: "M10.0013 4.16663V15.8333M10.0013 15.8333L15.8346 9.99996M10.0013 15.8333L4.16797 9.99996", stroke: "currentColor", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
